import {FC, PropsWithChildren, useEffect} from 'react';
import {StepsFormContext, useStepsForm} from '../../contexts';
import {useStepStore} from '../../store/useStepStore';

export const FormProvider: FC<PropsWithChildren> = ({children}) => {
  const steps = useStepStore((s) => s.steps);
  const form = useStepsForm({steps});

  useEffect(() => {
    form.reset({steps});
  }, [steps]);

  return <StepsFormContext.Provider value={{form}}>{children}</StepsFormContext.Provider>;
};
